import superagent from 'superagent';
import * as ApiService from './ApiService';

const baseUrl = 's3-storages';
export const getSecuredURL = async (request: {
    s3Key: string;
    s3Bucket: string;
}) => {
    const response = await ApiService.post(
        true,
        `${baseUrl}/getSecuredUrl`,
        request
    );
    return response.securedUrl;
};

export interface VideoUploadFileRequest {
    uploadUrl: string;
    file: File;
}

export const getRequirementUploadMetaData = async (
    request: RequirementUploadUrlRequest
) => {
    return getRequirementUploadUrl(request);
};

export const uploadVideoFile = async (request: VideoUploadFileRequest) => {
    try {
        const fileBuffer = await fileToArrayBuffer(request.file);
        await uploadVideoFileToSecuredUrl(
            request.uploadUrl,
            fileBuffer as ArrayBuffer
        );
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export interface RequirementUploadUrlRequest {
    fileName: string;
    resourceType: string;
    documentId: number;
    photoType: string;
    modelName: string;
}

const getRequirementUploadUrl = async (
    request: RequirementUploadUrlRequest
) => {
    return ApiService.post(true, `${baseUrl}/getRequirementUploadUrl`, request);
};

const uploadVideoFileToSecuredUrl = (url: string, file: ArrayBuffer) => {
    const headers = extractS3Headers(url);
    return superagent.put(url).send(file).set(headers);
};

export const extractS3Headers = (url: string) => {
    try {
        const parameters = [
            'response-content-disposition',
            'Content-Type',
            'x-amz-security-token',
            'AWSAccessKeyId',
            'Expires',
            'x-amz-meta-documentid',
            'x-amz-meta-filename',
            'x-amz-meta-modelname',
            'x-amz-meta-phototype',
            'x-amz-meta-resourcetype',
            'x-amz-meta-requirementid',
            'x-amz-meta-uuid',
        ];

        const headersMapping = new Map([
            ['response-content-disposition', 'Content-Disposition'],
        ]);

        // Use the URL constructor to parse parameters
        const parsedUrl = new URL(url);
        const params = parsedUrl.searchParams;

        // 1. Extract Content-Type (Essential for S3 PUT)
        return parameters.reduce((headers, key) => {
            if (params.has(key)) {
                const headerName = headersMapping.get(key) || key;
                headers[headerName] = params.get(key);
                if (headerName === 'x-amz-meta-filename') {
                    headers[headerName] = encodeURIComponent(params.get(key));
                }
            }
            return headers;
        }, {});
    } catch (error) {
        console.error('Failed to parse URL:', error);
        return {};
    }
};

const fileToArrayBuffer = (
    file: File
): Promise<ArrayBuffer | string | null> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
};
